import React from "react";
import Helmet from "react-helmet";

import Header from "../components/Layout/Header.jsx";
import Footer from "../components/Layout/Footer.jsx";
import TopGradient from "../components/Layout/TopGradient.jsx";
import TopNavigation from "../components/Layout/TopNavigation.jsx";

import "./index.css";

import faviconImage from "../../res/CI/favicon.png";

export default class Index extends React.Component
{
    render () {
        return (
            <div>
                <Helmet defaultTitle="Risag e.U. - Edelstahlverarbeitung, Messerschleiferei und Scherenschleiferei"
                        titleTemplate="Risag e.U. - %s"
                >
                    <link rel="shortcut icon" href={faviconImage} />
                    <meta name="description" content="Ihr Spezialist in Sachen Edelstahl. Ihre Messerschleiferei und Scherenschleiferei im Bezirk Feldkirch, in Liechtenstein und Umgebung. Für gewerbliche und private Kunden." />
                </Helmet>

                <TopGradient />
                <Header />

                <hr className="is-hidden-lg" />
                <TopNavigation />
                <hr className="is-hidden-lg" />

                {this.props.children()}

                <hr />
                <Footer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/index.js